import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel, ApiVisa, PagingResponseModel } from '../../shared';
import { Core2Config } from '../../shared';
import {
  PricingSchemeLinkContainerModel
} from '../../../../../../models/aggregates/erp/pricing-scheme/pricing-scheme-link-container.model';
import { Observable } from 'rxjs';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class PricingSchemeLinkService extends BaseApiPublicLoginTemplateService<PricingSchemeLinkContainerModel, PricingSchemeLinkContainerModel, PricingSchemeLinkContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'pricing-scheme-link';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'pricing-scheme-link';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'pricing-scheme-link';
    this.httpClient = http;
  }

  public getSalesSidePricingSchemes(dtoObject: any,appletGuid : string,tenantGuid: string,appletLoginSubjectRank: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let salesSideUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      salesSideUrl = this.apiUrl + '/sales-prices/backoffice-ep?appletGuid='+appletGuid+'&tenantGuid='+tenantGuid+'&appletLoginSubjectRank='+appletLoginSubjectRank;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      salesSideUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }


  public getPurchaseSidePricingSchemes(dtoObject: any,appletGuid : string,tenantGuid: string,appletLoginSubjectRank: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let purchaseSideUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      purchaseSideUrl = this.apiUrl + '/purchase-prices/backoffice-ep?appletGuid='+appletGuid+'&tenantGuid='+tenantGuid+'&appletLoginSubjectRank='+appletLoginSubjectRank;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      purchaseSideUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public getChildToParentPricing(guid: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/child-to-parent-pricing/' + guid;
    return this.httpClient.get<PagingResponseModel<PricingSchemeLinkContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public getPricingSchemeByGuid(guid_pricing_scheme_hdr : string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      url = this.apiUrl + '/backoffice-ep/query?guid_pricing_scheme_hdr='+guid_pricing_scheme_hdr;
    }
    return this.httpClient.get<ApiResponseModel<any>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  public updateGroupItemPricingWithChildItemPricing(dtoObject: any, updateChildItem : boolean, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    let url;
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
      url = this.apiUrl + '/update-with-child-item-pricing/backoffice-ep/'+updateChildItem;
    }
    return this.httpClient.put<ApiResponseModel<any>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}


